const InjuryReport = () => {
  return "liste des blessures et des morts?";
};

export default InjuryReport;
